import ViewfinderQrcode from './ViewfinderQrcode';

export default ViewfinderQrcode;
